export default function HowLifeWorksContent() {
  return (
    <>
      With Life™, staying connected is simple, smart, and always in your
      control.
      <br />
      <strong>Here's how it works: </strong>
      When you make a call to a new mobile number, Life automatically detects
      the call and prompts you — asking if you'd like to share your contact
      details with the person you just called. If you agree, your Life profile
      is sent instantly. The recipient receives a text (SMS) message containing
      the details you've chosen to share — like your name, phone numbers, email,
      photo, and even links to your social media profiles.
      <br />
      <br />
      Inside the text is a clickable link that opens a personalized Life portal
      page. From there, the recipient can download your contact card directly to
      their phonebook with a single tap. It's that easy! You'll make it
      effortless for friends, family, colleagues, and even customers to reach
      you.
      <br />
      <br />
      You're always in control of your personal information. You decide what to
      share, and you can update your Life profile anytime. Simply go to
      Life.fun, log in, and add or edit your contact details. Creating a Life
      portal is completely free — though mobile operator data rates may apply,
      and standard rates apply for sending contact details via the Life service.
      <br />
      <br />
      To get started, just enter your name when prompted. A Life contact card
      will be automatically generated for you, ready to be shared. You'll also
      receive invitations and reminders to enhance your Life profile — like
      adding a photo or more details — so your contact card is as helpful and
      complete as you want it to be.
      <br />
      <br />
      Prefer not to receive Life prompts? No problem. Just go to your mobile
      operator's SIM services menu and turn off the service. It may appear under
      names like CallerXchange, LinkUp, Life, or something similar.
      <br />
      <br />
      Stay connected — on your terms — with Life.
    </>
  );
}
